import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const screenshotMachine = defineConnector({
  identifier: "screenshotMachine",
  name: "ScreenshotMachine",
  tagLine: "Website screenshot capture API",
  logo,
  protocol: "http",
  tags: ["documents"],
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your ScreenshotMachine API key",
      items: [
        {
          kind: "markdown",
          content:
            "In ScreenshotMachine, copy your API key from the dashboard. The API sends it as the `key` query parameter.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.screenshotmachine.com/?url=https%3A%2F%2Fexample.com&dimension=1024x768&format=png",
  },
  defaultUrlPattern: () => "https://api\\.screenshotmachine\\.com/.*",
});
